import * as Status from '../../../constants/status';
import { partitionByGpsValidity } from '../../../utils/nsirMapConfig';
import {
  BACKLOG_STATUSES,
  FINALIZADAS_STATUSES,
  KPI_KEYS,
  PRESET_KEYS,
} from './constants';

const EM_INSPECAO_STATUSES = [Status.EM_INSPECAO, Status.EM_CRIACAO];

export const filterNsirsByKpi = (validas, activeKpi) => {
  if (!activeKpi || activeKpi === KPI_KEYS.TOTAL) return validas;

  switch (activeKpi) {
    case KPI_KEYS.ANOMALIAS:
      return validas.filter((n) => n.anomalia === true);
    case KPI_KEYS.AGUARDANDO:
      return validas.filter((n) => n.status === Status.AGUARDANDO_INSPECAO);
    case KPI_KEYS.EM_INSPECAO:
      return validas.filter((n) => EM_INSPECAO_STATUSES.includes(n.status));
    case KPI_KEYS.FINALIZADAS:
      return validas.filter((n) => FINALIZADAS_STATUSES.includes(n.status));
    default:
      return validas;
  }
};

export const getDisplayNsirs = (nsirs, { activeKpi, activePreset }) => {
  const { validas } = partitionByGpsValidity(nsirs);

  if (activePreset === PRESET_KEYS.BACKLOG) {
    return validas.filter((n) => BACKLOG_STATUSES.includes(n.status));
  }

  if (activePreset === PRESET_KEYS.ANOMALIAS) {
    return validas.filter((n) => n.anomalia === true);
  }

  if (activePreset === PRESET_KEYS.COMPLETO && !activeKpi) {
    return validas;
  }

  return filterNsirsByKpi(validas, activeKpi);
};

export const shouldFitBounds = (activeKpi, activePreset) => {
  if (activePreset === PRESET_KEYS.GPS || activePreset === PRESET_KEYS.COMPLETO) {
    return activeKpi != null && activeKpi !== KPI_KEYS.TOTAL;
  }
  if (activePreset === PRESET_KEYS.BACKLOG || activePreset === PRESET_KEYS.ANOMALIAS) {
    return true;
  }
  return activeKpi != null && activeKpi !== KPI_KEYS.TOTAL && activeKpi !== KPI_KEYS.GPS_ERRORS;
};

export const presetToKpi = (preset) => {
  if (preset === PRESET_KEYS.ANOMALIAS) return KPI_KEYS.ANOMALIAS;
  if (preset === PRESET_KEYS.BACKLOG) return null;
  return null;
};
